// A company's own fields on a record's form (Studio step 3, 2026-10-19): the
// controls wait in a holder and move to where their anchor says — before or
// after a field of the form (found by its label), the top or the bottom —
// the way page blocks do. Shared by the page and the chat's dashed preview.

import { findElementLandmark } from "./anchor_element"

const norm = (s) => (s || "").replace(/\*/g, "").replace(/\s+/g, " ").trim().toLowerCase()
const visible = (n) => !!n && n.getClientRects().length > 0
const ours = (n) => n.closest("#studio-bubble, [data-custom-field], [data-studio-ghost], [data-custom-fields-target='holder']")

// The form's landmarks in page order: {type: "field"|"heading", text, el} — el is the
// box a new field sits beside (a label's parent, or the heading itself).
export function fieldLandmarks(root) {
  const out = []
  if (!root) return out
  root.querySelectorAll("h2, h3, label").forEach((n) => {
    if (ours(n) || !visible(n)) return
    const label = (n.textContent || "").replace(/\*/g, "").replace(/\s+/g, " ").trim()
    const text = norm(label)
    if (!text || text.length > 120) return
    if (n.tagName === "LABEL") {
      const box = n.querySelector("input, select, textarea") ? (n.parentElement || n) : (n.parentElement || n)
      out.push({ type: "field", text, label, el: box })
    } else {
      out.push({ type: "heading", text, label, el: n })
    }
  })
  const counts = {}
  out.forEach((l) => { const k = `${l.type}:${l.text}`; l.index = counts[k] || 0; counts[k] = l.index + 1 })
  return out
}

export function findFieldLandmark(lm, root) {
  if (!lm) return null
  if (lm.type === "element") return findElementLandmark(lm, root)
  if (!lm.text) return null
  const want = norm(lm.text), type = lm.type || "field", idx = +lm.index || 0
  const all = fieldLandmarks(root).filter((l) => l.type === type && l.text === want)
  return (all[idx] || all[0])?.el || null
}

// Puts `el` where `anchor` says; the holder (the bottom of the form) when the
// landmark is gone. Returns the spot used.
export function placeField(el, anchor, { root, holder } = {}) {
  const spot = anchor?.spot || "form_bottom"
  if (spot === "form_top" && root) {
    const first = fieldLandmarks(root).find((l) => l.type === "field")?.el
    if (first && first.parentNode) { first.parentNode.insertBefore(el, first); return "form_top" }
  }
  if ((spot === "before" || spot === "after") && anchor.landmark) {
    const target = findFieldLandmark(anchor.landmark, root)
    if (target && target.parentNode) {
      if (spot === "before") target.parentNode.insertBefore(el, target)
      else target.parentNode.insertBefore(el, target.nextSibling)
      return spot
    }
  }
  if (holder) { holder.appendChild(el); return "form_bottom" }
  return null
}
